import 'core-js/stable';
import 'regenerator-runtime/runtime';

import '../../bootstrap';
import $ from 'jquery';
import { device } from '../../_modules/device_decision';
import 'slick-carousel';
import 'jquery-colorbox';

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  var $madomoFilter = $('.madomoFilter [data-filter]'),
    $madomolist = $('.madomolist [data-category]');

  $madomoFilter.on('click', function(e) {
    e.preventDefault();
    var $this = $(this);

    $madomoFilter.removeClass('active');
    $this.addClass('active');

    var $filterColor = $this.attr('data-filter');

    if ($filterColor == 'all') {
      $madomolist
        .removeClass('is-animated')
        .fadeOut()
        .promise()
        .done(function() {
          $madomolist.addClass('is-animated').fadeIn();
        });
    } else {
      $madomolist
        .removeClass('is-animated')
        .fadeOut()
        .promise()
        .done(function() {
          $madomolist
            .filter('[data-category~="' + $filterColor + '"]')
            .addClass('is-animated')
            .fadeIn();
        });
    }
  });
  $('.partsrail-item-subslider').slick({
    speed: 900,
    autoplay: true,
    autoplaySpeed: 6000,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<div class="prev"><img src="../../images/items/parts-rail/icon_prev.png" alt="prev" /></div>',
    nextArrow: '<div class="next"><img src="../../images/items/parts-rail/icon_next.png" alt="next" /></div>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: false,
        },
      },
    ],
  });


  //colorbox iframe 16:9 高さ調整
  var frameH;
  if(device == 'sp'){
    let windowW = $(window).width();
    frameH = (windowW * .50625 + 30) + 'px';
  }else{
    frameH = '90%';
  }

  $('.js-youtube').colorbox({
    iframe: true,
    innerWidth: 640,
    innerHeight: 360,
    maxWidth: '90%',
    maxHeight: frameH
  });

  $('.single').colorbox({
    maxWidth:"90%",
    maxHeight:"90%",
    opacity: 0.7
  });
  
  /*-------------
  記事一覧 もっと見る
  -------------*/
  const popItems = document.querySelectorAll('.js-popular-items');
    
  if(popItems.length){
    Array.from(popItems).forEach(items => {
      const popItem = items.querySelectorAll('.madomo-popular--item');
      let showMoreBtn;
      let showIndex = 6;
      
      if(popItem.length > showIndex){
        //ボタンの作成
        showMoreBtn = document.createElement('div');
        showMoreBtn.className = 'showMore-btn';
        showMoreBtn.innerHTML = 'もっと見る';
        items.after(showMoreBtn);
      } else {
        return false;
      }
      
      showMoreBtn.addEventListener('click',() => {
        showIndex += 6;
        
        Array.from(popItem).forEach(function(item,index){
          if((index + 1) <= showIndex){
            item.classList.add('is--show');
            
            if((index + 1) == popItem.length){
              showMoreBtn.parentNode.removeChild(showMoreBtn);
            }
          }
        });
      });
    });
  }
});
